import * as React from 'react'
import { htmlDecode } from 'DVWebNodeUtils'

export interface DecodedTextProps {
    string: string
}

export const DecodedText: React.ComponentType<DecodedTextProps> = ({
    string,
}: DecodedTextProps) => {
    const decodedText = htmlDecode(string)
    return <>{decodedText}</>
}

// Add displayName to preserve the component name on snapshot testing
DecodedText.displayName = 'DecodedText'